import { LocalDate } from '@js-joda/core';

import { Availability, AvailabilityQuery } from '@dreryk/egabinet-appointment-frontend-api';
import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

import { useCqrsGet, UseCqrsQueryResult } from '@dreryk/command-query-react-common';

export const useGetAvailability = (
   id: number,
   availabilityDate: LocalDate,
   practitionerId: PractitionerId
): UseCqrsQueryResult<Availability> => {
   return useCqrsGet<Availability>(() => {
      const query = new AvailabilityQuery();
      query.id = id;
      query.availabilityDate = availabilityDate;
      query.practitionerId = practitionerId;
      return query;
   });
};
